module.exports = __webpack_public_path__ + "ci_vendor_samba.ce012.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_samba.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_samba.svg
// module chunks = main